// Vue libraries
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// Our libraries
import App from "./App.vue";
import router from "./router";

// Third-party libraries
import { firestorePlugin } from "vuefire";
import VueSweetalert2 from "vue-sweetalert2";
import VueGtag from "vue-gtag";
import Toasted from "vue-toasted";

Vue.use(firestorePlugin);
Vue.use(VueSweetalert2, {
    confirmButtonColor: "#fe5775",
    width: "48em",
});
Vue.use(
    VueGtag,
    {
        config: { id: "UA-158773661-1" },
    },
    router
);
Vue.use(Toasted);

// Let's avoid that console print while developing
Vue.config.productionTip = false;

new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");
